export enum EventActions {
  BEFORECLIENTADDEDIT = 'before_client_add_edit',
  BEFORELOANADD = 'before_loan_add',
  BEFORELOANDISBURSE = 'before_loan_disburse',
  BEFOREENTRYADDEDIT = 'before_entry_add_edit',
  BEFORECONVADDEDIT = 'before_conv_add_edit',
  BEFORELOANCOVER = 'before_loan_cover',
  BEFORELOANVISA = 'before_loan_visa',
  BEFORECOLLATERALADDEDIT = 'before_collateral_add_edit',
  BEFOREUCCPAY = 'before_ucc_pay',
  ENTRYAUTH = 'entry_auth',
  ENTRYDELAUTH = 'entry_delauth',
  CONVAUTH = 'conv_auth',
  CONVDELAUTH = 'conv_delauth',
  VIEW = 'view',
}

type ClientType =
  | {
      ClientID: number | string
      HashSum_ClientID_: string
    }
  | {
      Name: string
      Surname: string
      Name_ALT: string
      Surname_ALT: string
      Cellphone: string
    }

export interface BeforeClientAddEditParams {
  SP_ACT: number
  AMLOperTypeID: number
  Name: string
  Surname: string
  Name_ALT: string
  Surname_ALT: string
  PersonalNo: number | string
  DateOfBirth: string
  DocNo: number | string
  FullName: string
  CTCode: number | string
  CitizenshipID: number | string
  ClientType: number | string
  CellPhone: string
  ClientID: number | string
  HashSum_ClientID_: string
}

export type BeforeLoanAddParams = {
  SP_ACT?: number
  AMLOperTypeID: number
  ClientID: number | string
  HashSum_ClientID_: string
  Amount: number | string
  CCY: string
}

export type BeforeLoanAddServerData = {
  Data: {
    ErrorLevel: number
    WHLSessionID: number
    HashSum_WHLSessionID_: string
  }
}

export interface BeforeLoanDisburseParams {
  AMLOperTypeID: number
  ClientID: number | string
  HashSum_ClientID_: string
  Amount: number | string
  CCY: string
  LoanID: number | string
  HashSum_DebitAccID_: number | string
  HashSum_LoanID_: number | string
  IDDocID: number
  HashSum_IDDocID_: string
}

export type BeforeLoanDisburseServerData = BeforeLoanAddServerData

export type BeforeEntryAddEditParams = {
  SP_ACT: number
  AMLOperTypeID: number
  Amount: number | string
  CCY: string
  PersonalNo: number | string
  OperDate: string
  ClientType: number | string
  OperTypeID: number
  DebitAccID: number
  HashSum_DebitAccID_: string
  CreditAccID: number
  HashSum_CreditAccID_: string
  IDDocID: number | string
  HashSum_IDDocID_: string
} & ClientType &
  (
    | {
        MoneyTransferCountryID: number | string
        MoneyTransferAgent: number | string
        MoneyTransferSystemID: number | string
      }
    | {}
  )

export type BeforeEntryAddEditServerData = BeforeLoanAddServerData

export type BeforeConvAddEditParams = {
  SP_ACT: number
  AMLOperTypeID: number
  OperTypeID: number
  Amount: number | string
  AmountB: number | string
  CCY: string
  CCYB: string
  OperDate: string
  DebitAccID: number | string
  HashSum_DebitAccID_: number | string
  CreditAccID: number | string
  HashSum_CreditAccID_: string
  IDDocID: number | string
  HashSum_IDDocID_: string
  ClientType: number | string
} & ClientType

export type BeforeConvAddEditServerData = BeforeLoanAddServerData

export interface BeforeLoanCoverParams {
  AMLOperTypeID: number
  OperTypeID: number | undefined
  LoanID: number | string
  HashSum_LoanID_: string
  ClientID: number | string
  HashSum_ClientID_: string
  Amount: number | string
  CCY: string
  IDDocID: number | string
  HashSum_IDDocID_: string
}

export type BeforeLoanCoverServerData = BeforeLoanAddServerData

export interface BeforeLoanVisaParams {
  AMLOperTypeID: number
  ClientID: number | string
  HashSum_ClientID_: string
  LoanID: number | string
  HashSum_LoanID_: string
}

export type BeforeLoanVisaServerData = {
  Data: any
  ErrorLevel: number
  WHLSessionID: number
  HashSum_WHLSessionID_: string
}

export type BeforeCollateralAddEditParams = BeforeLoanAddParams
export type BeforeCollateralAddEditServerData = BeforeLoanVisaServerData

export interface BeforeUccPayParams {
  AMLOperTypeID: number
  OperTypeID: number
  ClientID: number | string
  HashSum_ClientID_: string
  Amount: number | string
  IDDocID: number | string
  HashSum_IDDocID_: string
  CCY: string
}

export type BeforeUccPayServerData = BeforeLoanVisaServerData

export interface EventsViewParams {
  WHLSessionID: number | string
  HashSum_WHLSessionID_: string
}

export interface EventsViewServerData {
  Data: any
}

export interface EventFailure {
  message: string
}

export enum EventServiceErrorCode {
  GENERAL,
}
